(function () {
  let mount = document.getElementById('custom-quote-mount');

  function ensureMount() {
    if (mount && document.body.contains(mount)) return mount;
    // place near product content if possible
    const host = document.querySelector('section[id^="MainProduct"], .product__info-wrapper, .product') || document.body;
    mount = document.createElement('div');
    mount.id = 'custom-quote-mount';
    mount.hidden = true;
    host.appendChild(mount);
    return mount;
  }

  async function loadSection() {
    const target = ensureMount();
    if (target.dataset.loaded === 'true') return target;

    const url = `${location.pathname}?section_id=product-custom-quote`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load custom quote section');

    target.innerHTML = await res.text();
    target.hidden = false;
    target.dataset.loaded = 'true';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const first = target.querySelector('input,textarea,select,button');
    if (first) first.focus();
    return target;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-quote]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try { await loadSection(); }
    catch (err) { console.error(err); alert('Sorry—couldn’t load the form.'); }
    finally { btn.removeAttribute('aria-busy'); }
  });
})();
